import script from "./RecCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecCard.vue?vue&type=script&setup=true&lang=ts"

import "./RecCard.vue?vue&type=style&index=0&id=11b08258&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11b08258"]])

export default __exports__